import { render, staticRenderFns } from "./exhibition-control-controlCase.vue?vue&type=template&id=6fa71f5b&scoped=true&"
import script from "./exhibition-control-controlCase.vue?vue&type=script&lang=js&"
export * from "./exhibition-control-controlCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa71f5b",
  null
  
)

export default component.exports